export enum TaxStatusEnum {
  CORPORATION = 'corporation',
  LIMITED_LIABILITY_COMPANY = 'llc',
  TAX_EXEMPT_ORGANIZATION = 'taxExempt',
  GOVERNMENT_AGENCY = 'government',
}
